import React, { forwardRef, useImperativeHandle, useState } from "react";
import { slugify } from "../../utils";
import SuggestionItem from "./SuggestionItem";

interface SuggestionContainerProps {
	isOpen: boolean;
	items: any[];
  langId: number;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
}

export interface SuggestionContainerRef {
	goPrevious: () => void;
	goNext: () => void;
	moveLocation: () => void;
}


const SuggestionContainer = forwardRef(({isOpen, items, langId, onMouseEnter, onMouseLeave}: SuggestionContainerProps, ref) => {
	const [tabIndex, setTabIndex] = useState<number>(0);

	function updateTabIndex(condition: boolean, newValeIndex: number, elseValueIndex: number) {
    if (condition) {
      setTabIndex(newValeIndex);
    } else {
      setTabIndex(elseValueIndex);
    }
  }

  useImperativeHandle(ref, (): SuggestionContainerRef => ({

    goPrevious() {
      updateTabIndex(tabIndex > 0, tabIndex - 1, items.length - 1);
    },

		goNext() {
			updateTabIndex(tabIndex < (items.length - 1), tabIndex + 1, 0);
		},

		moveLocation() {
			let href = '/help/q-'.concat(slugify(items[tabIndex]._source[`question_${langId}`]), '/', items[tabIndex]._id);
			if (items[tabIndex]._source['is_link']) {
				href = items[tabIndex]._source[`answer_${langId}`];
			}
			window.location.assign(href);
		}

  }));

	return (
		<div
			id="faq-suggest"
			className={"faq-suggest " + (isOpen ? 'open' : 'hide')}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			{items.map((item, i) => <SuggestionItem key={i} item={item} langId={langId} isSelected={i === tabIndex} />)}
		</div>
	)
});

export default SuggestionContainer;
